import { useSelector } from 'react-redux';

/**
 * Finds the dossier_content paragraph containing the current article.
 * @param paragraphs - Array of paragraph entities from dossier.field_paragraphs
 * @returns The matching paragraph entity or null
 */
const useMatchingDossierContentParagraph = (paragraphs: any[]) => {
  const currentEntityId = useSelector(
    (state: any) => state.getIn(['entity', 'entityId'], null),
  );

  if (!paragraphs || !currentEntityId) {
    return null;
  }

  // Filter to dossier_content paragraphs
  const dossierContentParagraphs = paragraphs.filter(
    (paragraph: any) => paragraph.entity?.type?.[0]?.target_id === 'dossier_content',
  );

  // Find the paragraph containing the current article
  const matchingParagraph: any = dossierContentParagraphs.find(
    (paragraph: any) => {
      const items = paragraph.entity?.field_dossier_content_item ?? [];
      return items.some((item: any) => {
        const targetId = item.entity?.field_content_dossier?.[0]?.target_id;
        return Number(targetId) === Number(currentEntityId);
      });
    },
  );

  return matchingParagraph ?? null;
};

export default useMatchingDossierContentParagraph;
